"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const inputs_1 = require("../../../../inputs");
const validation_1 = require("./validation");
const ParameterDialogForm = (props) => {
    const { open, mode, selectedItem, parameters, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, parameterName, parameterType, parameterValue, parameterMinValue, parameterMaxValue } = selectedItem;
    const fixedValues = {
        id,
        parameterName,
        parameterType,
        parameterValue,
        parameterMinValue,
        parameterMaxValue,
    };
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, ...rest, children: (0, jsx_runtime_1.jsx)(inputs_1.ParameterInput, { service: service, parameters: parameters }) }));
};
exports.ParameterDialogForm = ParameterDialogForm;
//# sourceMappingURL=index.js.map